import { serverAxiosPromise } from '@alltrails/shared/utils/requests/requestBase';

import { EditItemsReponse } from '../../types/responses';

export enum EditItemType {
  Trail = 'trail',
  Area = 'area',
  Alert = 'alert'
}

export enum EditItemStatus {
  Pending = 'P',
  Rejected = 'R',
  Accepted = 'A',
  AdminReview = 'N',
  Applied = 'L'
}

const editItemsRequest = async (id: number, type: EditItemType, status: EditItemStatus): Promise<EditItemsReponse> => {
  const url = `/api/alltrails/users/${id}/edits`;
  const params = { type, status };

  const { data } = await serverAxiosPromise({ url, params });

  return data;
};

export { editItemsRequest };
